module.exports = __webpack_public_path__ + "28042690b69f4c26b9fb5d018cf288c4.svg";